import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import React from 'react';
import { useSelector } from 'react-redux';
import { routes } from '../../common/routes';
import { AppState, campagneSelector } from '../../common/store/store';
import { MasterViewPage } from './MasterPage';


export const NotFound = () => {

    const campagne = useSelector((state: AppState) => campagneSelector.selectById(state, state.viewCampagne.campagneId ?? 0));

    if (campagne &&
        campagne.id &&
        campagne.componentRoute &&
        campagne.componentRoute in routes) {
        return routes[campagne.componentRoute].component;
    } else return <MasterViewPage>
        <Container sx={{ textAlign: 'center' }}>
            <Typography component='h1'>Oooops !</Typography>
            <p><Typography>L'élément que vous cherchez est introuvable.</Typography></p>
            <p><Typography>Code d'erreur 404.</Typography></p>
        </Container>

    </MasterViewPage>;
};
